import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

const ProtectedRoute = ({ component: Component, allowedRoles = [], ...rest }) => {
  const isAuthenticated = sessionStorage.getItem("isAuthenticated");
  const userPermissions = useSelector(state => state.root.user.permissions) || [];
  const userRole = useSelector(state => state.root.user.role?.name);

  const isSystemAdmin = userRole === "Admin";
  const hasPermission =
    allowedRoles.length === 0
      ? true // No restriction, allow
      : userPermissions.some(permission => allowedRoles.some(role => permission.name.includes(role)));

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (isSystemAdmin || !isSystemAdmin) {
    return <Component {...rest} />;
  }

  if (hasPermission) {
    return <Component {...rest} />;
  }

  // If user has some permissions but none match allowedRoles, redirect to /dashboard
  if (userPermissions.length > 0) {
    return <Navigate to="/dashboard" />;
  }

  // Otherwise unauthorized
  return <Navigate to="/unauthorized" />;
};

ProtectedRoute.propTypes = {
  component: PropTypes.any,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
};

export default ProtectedRoute;
